import { IonCol, IonGrid, IonRow } from '@ionic/react';
import styles from './TransactionListControl.module.css';
import CsvDownloadButton from './CsvDownloadButton';

const TransactionListControl: React.FC = () => {
  return (
    <IonGrid fixed={true} className={styles.grid}>
      <IonRow>
        <IonCol className={styles.column}>
          <CsvDownloadButton />
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default TransactionListControl;
